module.exports = __webpack_public_path__ + "static/img/bonus_7.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_7.png
// module id = 9CKZ
// module chunks = 0